// GSTIN format regex
export const GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
export const isValidGstinFormat = (gstin: string): boolean => GSTIN_REGEX.test(gstin);

// GSTIN: first two digits = state TIN → state letter code
export const GSTIN_STATE_CODE_MAP: Record<string, string> = {
  '01': 'JK', '02': 'HP', '03': 'PB', '04': 'CH', '05': 'UK', '06': 'HR',
  '07': 'DL', '08': 'RJ', '09': 'UP', '10': 'BR', '11': 'SK', '12': 'AR',
  '13': 'NL', '14': 'MN', '15': 'MZ', '16': 'TR', '17': 'ML', '18': 'AS',
  '19': 'WB', '20': 'JH', '21': 'OD', '22': 'CG', '23': 'MP', '24': 'GJ',
  '25': 'DD', '26': 'DN', '27': 'MH', '29': 'KA', '30': 'GA', '31': 'LD',
  '32': 'KL', '33': 'TN', '34': 'PY', '35': 'AN', '36': 'TS', '37': 'AD',
  '38': 'LA',
};

export const extractStateFromGstin = (gstin: string): string | null => {
  if (!gstin || gstin.length < 2) return null;
  return GSTIN_STATE_CODE_MAP[gstin.substring(0, 2)] || null;
};

/** PAN is embedded in GSTIN at positions 3–12 (0-based index 2–11). */
export const extractPanFromGstin = (gstin: string): string | null => {
  if (!isValidGstinFormat(gstin)) return null;
  return gstin.substring(2, 12).toUpperCase();
};

// Name comparison for mismatch detection
// Strip common suffixes like Pvt, Ltd, Private, Limited, LLP, etc., uppercase, check containment
export const normalizeForComparison = (name: string): string => {
  return name
    .toUpperCase()
    .replace(/\b(PRIVATE|PVT|LIMITED|LTD|LLP|INC|CORP|CORPORATION|COMPANY|CO)\b/g, '')
    .replace(/[^A-Z0-9]/g, '')
    .trim();
};

export const namesMatch = (entityName: string, legalName: string, tradeName?: string): boolean => {
  const normalizedEntity = normalizeForComparison(entityName);
  const normalizedLegal = normalizeForComparison(legalName);
  const normalizedTrade = tradeName ? normalizeForComparison(tradeName) : '';

  if (!normalizedEntity || !normalizedLegal) return true; // Can't compare empty strings

  // Check if entity name contains legal name or vice versa
  if (normalizedEntity.includes(normalizedLegal) || normalizedLegal.includes(normalizedEntity)) return true;
  // Check trade name too
  if (normalizedTrade && (normalizedEntity.includes(normalizedTrade) || normalizedTrade.includes(normalizedEntity))) return true;

  return false;
};

// Multi-state display name
export const getDisplayNameWithState = (name: string, gstin: string): string => {
  const state = extractStateFromGstin(gstin);
  return state ? `${name} - ${state}` : name;
};
